import { AiModal, AliOssImage } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import { tryURL } from '@aigc/toolkit';
import type { Pagination } from '@aigc/types';
import { useQuery } from '@tanstack/react-query';
import { Card, Spin } from 'antd';
import { queryUploadedFiles } from '../features/file/api';
import type { FileDto } from '../features/file/model';

export async function queryImages(pagination?: Pagination) {
  const data = await queryUploadedFiles(pagination);
  return data;
}

export const UploadedImageListModal = () => {
  const overlayRef = useOverlayRef<FileDto>();

  const { data, isLoading } = useQuery({
    queryKey: ['图片列表'],
    queryFn: () => {
      return queryImages({
        size: 30,
      });
    },
  });

  return (
    <AiModal
      title="图片选择"
      centered
      width={800}
      footer={null}
      onCancel={() => {
        overlayRef.close();
      }}
    >
      <Spin spinning={isLoading}>
        <div className="grid max-h-[70vh] grid-cols-2 gap-4 overflow-auto sm:grid-cols-4">
          {data?.items.map((item) => {
            const url = tryURL(item.oss_object_key, item.oss_host);

            return (
              <Card
                key={item.id}
                classNames={{
                  body: '!p-2',
                }}
                hoverable
                cover={
                  <AliOssImage
                    size={172}
                    src={url?.toString()}
                    preview={false}
                  ></AliOssImage>
                }
                onClick={() => {
                  overlayRef.close(item);
                }}
              >
                <Card.Meta
                  classNames={{ description: 'truncate' }}
                  description={item.filename}
                ></Card.Meta>
              </Card>
            );
          })}
        </div>
      </Spin>
    </AiModal>
  );
};
